import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('./views/LoginView.vue'),
    meta: { guestRoute: true }
  },
  {
    path: '/requests',
    component: () => import('./views/Requests/RequestsIndex.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/requests/add',
    component: () => import('./views/Requests/AddRequest/AddRequestIndex.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/uninstalls',
    component: () => import('./views/UninstallRequests.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/devices',
    component: () => import('./views/Devices/DevicesIndex.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/devices/edit/:id',
    component: () => import('./views/Devices/EditDevice.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/number-pools',
    component: () => import('./views/NumberPools/NumberPoolsIndex.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/number-pool/:id',
    component: () => import('./views/NumberPools/NumberPoolDetailsView.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/device-pool/:poolName/edit',
    component: () => import('./views/NumberPools/EditDevicePool.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/cucm-groups',
    component: () => import('./views/CucmGroups/CucmGroupsIndex.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/cucm-groups/edit/:groupName/:listName',
    component: () => import('./views/CucmGroups/EditCucmGroupList.vue'),
    meta: { authRoute: true }
  },
  ,
  {
    path: '/warehouse',
    component: () => import('./views/Warehouses/WarehousesIndex.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/warehouse/:id',
    component: () => import('./views/Warehouses/WarehouseDetailsView.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/models',
    component: () => import('@/views/Models/ModelsIndex.vue'),
    meta: { authRoute: true }
  },
  {
    path: '/models/:id',
    component: () => import('@/views/Models/ModelDetailsView.vue'),
    meta: { authRoute: true }
  },
  {
    path: '*',
    redirect: '/requests'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const { isLoggedIn } = store.getters

  const isAuthRoute = to.meta.authRoute
  if (isAuthRoute && !isLoggedIn) {
    //auth.returnUrl = to.fullPath
    store.dispatch('logout')
    next('/login')
    return
  }

  const isGuestRoute = to.meta.guestRoute
  if (isGuestRoute && isLoggedIn) {
    // auth.returnUrl = to.fullPath;
    next('/requests')
    return
  }

  next()
})

export default router
